import styled, { css } from "styled-components";

export const AboutPage = styled.section`
  height: 100%;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 4rem;
  width: 100%;
  will-change: contents;
  z-index: 1;
  transform-style: preserve-3d;
  animation: fadeIn 1s forwards;
  animation-delay: 2.5s;
  opacity: 0;
  overflow: hidden;

  @media (max-width: 1020px) {
    padding-right: 2rem;
  }
  @media (max-width: 900px) {
    padding: 3rem;
    grid-gap: 3rem;
  }
  @media (max-width: 725px) {
    flex-direction: column-reverse;
  }
  @media (max-width: 588px) {
    padding: 2rem;
  }
  @media (max-width: 360px) {
    padding: 1.3rem;
  }
  @media (max-width: 300px) {
    padding-right: 0.7rem;
  }

  h1 {
    color: #3bcfe3;
    font-weight: 400;
    font-family: "Lato", sans-serif;
    margin-top: 0;
    position: relative;
    margin-bottom: 40px;
    left: -10px;
    @media (max-width: 695px) {
      margin-bottom: 20px;
    }

    &:before {
      content: "<h1>";
      opacity: 0.3;
      color: #3bcfe3;
      font-size: 18px;
      font-family: "La Belle Aurore", cursive;
      position: absolute;
      margin-top: -10px;
      left: -10px;
      line-height: 18px;
    }

    &:after {
      content: "<h1/>";
      color: #3bcfe3;
      opacity: 0.3;
      font-size: 18px;
      font-family: "La Belle Aurore", cursive;
      line-height: 18px;
      position: absolute;
      left: -30px;
      bottom: -20px;
      margin-left: 20px;
    }
  }

  p {
    color: #D6D6D6;
    font-weight: 300;
    max-width: fit-content;
  }

  .text-zone {
    width: 47%;
    vertical-align: middle;
    display: table-cell;
    max-height: 90%;

    @media (max-width: 725px) {
      max-width: 45rem;
      width: 100%;
    }

    p {
      font-size: clamp(1rem, 2.5vw, 1.2rem);
      line-height: 26px;
      letter-spacing: 0.05rem;
      word-spacing: 0.15rem;
    }
  }
  .profile-img {
    transform: translate(30%, 50%);
    opacity: 0;
    width: 47%;
    display: flex;
    align-items: center;
    justify-content: center;
    max-height: 90%;

    @media (max-width: 725px) {
      max-width: 45rem;
      width: 100%;
    }
    @media (max-width: 500px) {
      margin-left: 3rem;
    }

    .profile-element {
      max-width: 18rem;
      width: 100%;
      height: 18rem;

      @media (max-width: 300px) {
        max-width: 14rem;
        height: 14rem;
      }

      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        border-radius: 20%;
      }
    }
    ${({ isVisible }) =>
      isVisible &&
      css`
        -webkit-transition: all 1.6s cubic-bezier(0.39, 0.575, 0.565, 1) 2s;
        transition: all 1.6s cubic-bezier(0.39, 0.575, 0.565, 1) 2s;
        transform: translate(0%, 0%);
        opacity: 1;
      `}
  }
`;
